import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { createButtonLink } from './ButtonLink';
import { WS10_BUTTON_LINK_BASE_CLASSNAME } from './Constants';
createComponents(".".concat(WS10_BUTTON_LINK_BASE_CLASSNAME), createButtonLink, NO_PATTERN_BUSINESS_LOGIC);
